module.exports = __webpack_public_path__ + "img/h5img48.a5bfc0c8.png";